module.exports = __webpack_public_path__ + "img/004郑威.32d043c0.jpg";